import React from 'react';
import {
  evaluationCheckListItems,
  getEvaluationStyles,
} from './evaluationCheckListUtilities';

export default function EvaluationChecklist({
  isNotEvaluable,
  data,
  translate,
}) {

  const checkList = evaluationCheckListItems(data);


  return (
    <>
      <div className='evaluation-list'>
        {checkList?.map((item, index) => {
          const { containerClass, iconWrapperClass, icon } =
            getEvaluationStyles(item, isNotEvaluable);
          return (
            <div
              key={index}
              className='evaluation-cell'
            >
              <div className={`evaluation-item ${containerClass}`}>
                <span>{translate(item.label)}</span>
                <span className={`me-2 ${iconWrapperClass}`}>{icon}</span>
              </div>
            </div>
          );
        })}
      </div>
      {data.agentEvaluations?.[0]?.isRisk && (
        <div className='alert-danger-wrapper mt-2'>
          ⚠️ Risk Detected: {data.agentEvaluations?.[0]?.riskReason}
        </div>
      )}
    </>
  );
}
